import { Component, Input, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Legend } from 'src/models/legend';

@Component({
  selector: 'app-legend-popover',
  templateUrl: './legend-popover.component.html',
  styleUrls: ['./legend-popover.component.scss'],
})
export class LegendPopoverComponent implements OnInit {
  @Input() legend: Legend;

  constructor(
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  cancel() {
    if (this.legend.config.displayAsPopover) {
      this.popoverCtrl.dismiss(false);
    } else {
      this.modalCtrl.dismiss(false);
    }
  }

  ok() {
    if (this.legend.config.displayAsPopover) {
      this.popoverCtrl.dismiss(true);
    } else {
      this.modalCtrl.dismiss(true);
    }
  }

}
